import axios from 'axios'
import { resolveMock } from '../mocks/handlers'

const Http = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

Http.interceptors.request.use(
  function (config) {
    config.headers.Authorization = localStorage.getItem('user-token')

    // ดัก request ก่อนออกจากเครื่องเมื่อเปิด mock (spec 013 Mock Layer)
    const mocked = resolveMock(config)
    if (mocked) {
      config.adapter = () => {
        const response = { ...mocked, config }
        if (mocked.status < 400) {
          return Promise.resolve(response)
        }
        // mock ที่ตอบ 4xx/5xx ต้อง reject แบบเดียวกับ axios จริง ไม่งั้นหน้าจอจะเห็นเป็นสำเร็จ
        const error = new Error(
          `Request failed with status code ${mocked.status}`
        )
        error.config = config
        error.response = response
        error.isAxiosError = true
        return Promise.reject(error)
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

Http.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default Http
